// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.

export const addNotificationState = (state, notification) => {
  // Ignore any notifications with a parent
  if (notification && !notification.parent_uuid) {
    state.notifications = [...state.notifications, notification];
  }
};

export const updateNotificationState = (state, notification) => {
  if (notification) {
    const index = state.notifications?.findIndex(
      n => n.lock_request_uuid === notification.lock_request_uuid
    );
    if (index !== -1 && state.notifications) {
      state.notifications[index] = {
        ...state.notifications[index],
        ...notification,
      };
    }
  }
};

export const deleteNotificationState = (state, notification) => {
  if (state.notifications) {
    state.notifications = state.notifications.filter(
      n => n.lock_request_uuid !== notification?.lock_request_uuid
    );
  }
};
